<template>
  <div class="card mb-4 option-big-image">
    <div class="text-center">
      <img :src="option.image | image('350x')">
    </div>
    <div class="card-body">
      <select class="custom-select" @change="onChange">
        <option v-for="(selectOption, index) in selectOptions" :key="index" :value="selectOption.value" :selected="selectOption.selected">
          {{ selectOption.label }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: null
    },
    option: {
      type: Object,
      default: null
    },
    optionDim: {
      type: Object,
      default: null
    }
  },
  computed: {
    selectOptions () {
      const values = []
      for (let i = Number.parseInt(this.optionDim.min); i <= Number.parseInt(this.optionDim.max); i += this.optionDim.step) {
        values.push({
          value: i,
          label: `${i} ${this.optionDim.unit}`,
          selected: this.option.value === i
        })
      }
      return values
    }
  },
  methods: {
    ...mapActions({
      setDimension: 'configurator/setDimension'
    }),
    onChange (e) {
      this.setDimension({
        type: this.type,
        value: e.target.value
      })
    }
  }
}
</script>
